
<row>
  <column>
    {{i + 1}}. Send
    <b>{{notification.subject}}</b>
    notification
    <b v-if="notification.displayTriggerString">{{notification.displayTriggerString}}</b>
    to
    <b>{{notification.recipientsToString}}</b>.
  </column>

  <suffix>
    <div class="dropdown">
      <button class="dropdown-toggle btn-icon clear-area controllers" :id="`notificationActionsButton_${notification.id}`" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <icon class="kebab"></icon>
        <span class="sr-only">More Actions Dropdown</span>
      </button>

      <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="NotificationActionsButton1">
        <li>
          <button @click="edit" type="button" class="dropdown-item">Edit</button>
        </li>
        <li>
          <button @click="showModal(vueModalID.confirmDeleteNotification)" type="button" class="dropdown-item">Delete</button>
        </li>
      </ul>
    </div>
  </suffix>

  <column size="100%" v-if="modalStateFor(vueModalID.confirmDeleteNotification).isVisible">
    <confirm-delete :state="modalStateFor(vueModalID.confirmDeleteNotification)"
                    :index="vueModalID.confirmDeleteNotification"
                    @toggle-modal="hideModal(vueModalID.confirmDeleteNotification)"
                    v-on:cancel="hideModal(vueModalID.confirmDeleteNotification)"
                    v-on:confirm="destroyNotification"></confirm-delete>
  </column>
</row>
